import React from 'react';
import { TextField } from '@material-ui/core';
import { withFormsy } from 'formsy-react';
import _ from '@lodash';

function TextFieldFormsy(props) {
	const importedProps = _.pick(props, [
		'autoComplete',
		'autoFocus',
		'children',
		'className',
		'defaultValue',
		'disabled',
		'FormHelperTextProps',
		'fullWidth',
		'id',
		'InputLabelProps',
		'inputProps',
		'InputProps',
		'inputRef',
		'label',
		'multiline',
		'name',
		'onBlur',
		'onChange',
		'onFocus',
		'onKeyPress',
		'placeholder',
		'required',
		'minRows',
		'rowsMax',
		'select',
		'SelectProps',
		'type',
		'variant',
		'aria-owns',
		'aria-haspopup',
		'onMouseEnter',
		'onMouseLeave'
	]);

	const errorMessage = props.errorMessage;
	const value = props.value || '';

	function changeValue(event) {
		props.setValue(event.currentTarget.value);
		if (props.onChange) {
			props.onChange(event);
		}
	}

	return (
		<TextField
			{...importedProps}
			onChange={changeValue}
			value={value}
			error={Boolean(errorMessage)}
			helperText={errorMessage}
		/>
	);
}

export default React.memo(withFormsy(TextFieldFormsy));
